import { render } from "./ModalNovaEntrega.vue?vue&type=template&id=3cbdef84"
import script from "./ModalNovaEntrega.vue?vue&type=script&lang=js"
export * from "./ModalNovaEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__